import type { AppRouter } from "../../../server/build/rpc";
// import type { AppRouter } from "../../../server/src/rpc";
import { createTRPCClient } from "@trpc/react";
import type { inferProcedureInput, inferProcedureOutput } from "@trpc/server";
import { APP_VERSION_HEADER_KEY, TOKEN_HEADER_KEY } from "./backend";
import { getToken } from "./backend-api";

const unchecked_VITE_API_URL = import.meta.env.VITE_API_URL as string;
const RPC_URL = `${unchecked_VITE_API_URL}${unchecked_VITE_API_URL.includes("/api") ? "" : "/api"}/rpc`;

export const trpcClient = createTRPCClient<AppRouter>({
  url: RPC_URL,
  // fetch: async (a, b) => {
  //   const res = await fetch(a, b);

  //   console.log(res.status)
  //   if (res.status === 401) {
  //     const resCloned = res.clone();
  //     const body = await resCloned.json();
  //     console.log(body)

  //     // TODO: need to add this to response body in trpc context somehow
  //     if (body?.must_revalidate) {
  //       // storeAppData({ authInfo: defaultNotAuthed });
  //       localStorage.clear();
  //       window.location.pathname = "/login";
  //       throw new Error("must_revalidate");
  //     }
  //   }

  //   return res;
  // },
  // fetch: (a, b) => {
  //   return fetch(a, { ...b, credentials: "include" });
  // },
  headers: {
    [TOKEN_HEADER_KEY]: getToken() || undefined,
    [APP_VERSION_HEADER_KEY]: import.meta.env.VITE_VERSION,
  },
});

export type Person = Await<ReturnType<AppRouter["_def"]["queries"]["person"]["call"]>>;
export type Changelog = NonNullable<
  NonNullable<Await<ReturnType<AppRouter["_def"]["queries"]["prefetch"]["call"]>>>["changelog"]
>;

type TMutation = keyof AppRouter["_def"]["mutations"];
export type InferMutationInput<TRouteKey extends TMutation> = inferProcedureInput<AppRouter["_def"]["mutations"][TRouteKey]>;
export type InferMutationOutput<TRouteKey extends TMutation> = inferProcedureOutput<
  AppRouter["_def"]["mutations"][TRouteKey]
>;

type TQuery = keyof AppRouter["_def"]["queries"];
export type InferQueryOutput<TRouteKey extends TQuery> = inferProcedureOutput<AppRouter["_def"]["queries"][TRouteKey]>;
export type InferQueryInput<TRouteKey extends TQuery> = inferProcedureInput<AppRouter["_def"]["queries"][TRouteKey]>;

export type UserState = Await<ReturnType<AppRouter["_def"]["queries"]["me/state"]["call"]>>;

// const a = createReactQueryHooks()

// export interface RpcOutputs {
//   Library: InferQueryOutput<"library">;
// }

export default trpcClient;
